import { WHY } from "./data/content";
import Reveal from "./Reveal";

export const WhyJoin = () => (
  <section id="why" className="py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="label-mono">Why agents join</p>
            <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
              A better business, not just a bigger wage.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-slate-400">
              Every reason on this list comes from the same idea: the business you build should belong to
              you — and be worth more because of how you built it.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <ol className="grid gap-x-10 sm:grid-cols-2">
            {WHY.map((w, i) => (
              <Reveal key={w.title} delay={Math.min(i * 0.05, 0.35)}>
                <li className="flex gap-5 border-t border-white/10 py-6" data-testid={`why-item-${i + 1}`}>
                  <span className="font-mono text-sm font-semibold text-gold-light">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-display text-base font-bold tracking-tight text-white sm:text-lg">
                      {w.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-slate-400">{w.desc}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </div>
  </section>
);

export default WhyJoin;
